
export const SET_BLOGS = 'SET_BLOGS';
export const RESET_REDUX_STORE = 'RESET_REDUX_STORE';
